"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var expiryInMilliSeconds = 86400000;
var CookieManager = exports.default = /*#__PURE__*/function () {
  function CookieManager() {
    (0, _classCallCheck2.default)(this, CookieManager);
  }
  (0, _createClass2.default)(CookieManager, null, [{
    key: "isCookieEnabled",
    value: function isCookieEnabled() {
      CookieManager.createCookie('testCookie', 'testCookie');
      return CookieManager.readCookie('testCookie') === 'testCookie';
    }
  }, {
    key: "createCookie",
    value: function createCookie(name, value, days) {
      var secure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var expiry = arguments.length > 4 ? arguments[4] : undefined;
      if (typeof document !== 'undefined') {
        var expires = '';
        var https = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * expiryInMilliSeconds);
          expires = '; expires='.concat(date.toGMTString());
        } else if (expiry) {
          expires = '; expires='.concat(expiry.toGMTString());
        }
        if (secure && location.protocol === 'https:') {
          // eslint-disable-line
          https = ';secure';
        }
        document.cookie = name.concat('=', value, expires, '; path=/', https);
      }
    }
  }, {
    key: "readCookie",
    value: function readCookie(name) {
      var value;
      if (typeof document !== 'undefined') {
        var nameEQ = name.concat('=');
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
          }
          if (c.indexOf(nameEQ) == 0) {
            value = c.substring(nameEQ.length, c.length);
          }
        }
      }
      return value;
    }
  }, {
    key: "eraseCookie",
    value: function eraseCookie(name) {
      this.createCookie(name, '', -1);
    }
  }, {
    key: "getAllCookies",
    value: function getAllCookies() {
      if (typeof document !== 'undefined') {
        var cookies = document.cookie.split(';');
        if (cookies.length) {
          return cookies.map(function (cookie) {
            var _cookie$split = cookie.split('='),
              _cookie$split2 = (0, _toArray2.default)(_cookie$split),
              cookieName = _cookie$split2[0],
              cookieValues = _cookie$split2.slice(1);
            return (0, _defineProperty2.default)({}, cookieName.trim(), cookieValues.join('='));
          }).reduce(function (acc, curr) {
            return _objectSpread(_objectSpread({}, acc), curr);
          }, {});
        }
      }
      return {};
    }
  }]);
  return CookieManager;
}();